import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import language from './modules/language'
import profile from './modules/profileModule'
import students from './modules/students'
import config from './modules/config'
import student from './modules/studentModule'
import intervention from './modules/intervention'
import interactions from './modules/interactionsModule'
import exemptionModule from './modules/exemptionModule'
import closeIntervention from './modules/closeIntervention'
import hierarchy from './modules/hierarchyModule'
import rightDrawer from './modules/rightDrawer'
import information from './modules/information'
import undo from './modules/undo'
import admin from './modules/admin'
import dashboard from './modules/dashboardModule'
import resources from './modules/resources'
import attendance from './modules/attendanceModule'
import assessments from './modules/assessmentsModule'
import feeds from './modules/feedsModule'
import announcement from './modules/announcement'
import insights from './modules/insights'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  actions,
  getters,
  modules: {
    language,
    students,
    profile,
    config,
    student,
    intervention,
    hierarchy,
    rightDrawer,
    information,
    interactions,
    exemptionModule,
    undo,
    closeIntervention,
    admin,
    dashboard,
    resources,
    attendance,
    assessments,
    feeds,
    announcement,
    insights
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js